import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Nav, NavDropdown, MenuItem } from 'react-bootstrap';
import { push } from 'react-router-redux';
import { smoothlyMenu } from '../../layouts/Helpers';
import { Logout, TopHeader } from '../../common';

class TopNav extends Component {

  toggleNavigation(e) {
    e.preventDefault();
    $('body').toggleClass('mini-navbar');
    smoothlyMenu();
  }

  render() {
    const {
      user,
      dispatch,
      accounts,
      account
    } = this.props;

    const slug = account.slug || '';
    const title = (
      (accounts).filter(e => e.slug === slug)[0] || {}
    ).name || 'Accounts';

    const navLeft = (
      <Nav className='navbar-top-links'>
        <NavDropdown
          eventKey={1}
          title={title}
          id="basic-nav-dropdown"
          href='javascript:void(0);'
        >
          {accounts.map((a, i) => {
            const path = `/advertiser/home/accounts/${a.slug}/dashboard`;
            return (
              <MenuItem
                key={`account-${i}`}
                href='javascript:void(0);'
                onClick={() => dispatch(push(path))}
              >
                {a.name}
              </MenuItem>
            );
          })}
          <MenuItem
            href='javascript:void(0);'
            onClick={() => dispatch(push('/advertiser/home/accounts'))}
          >
            All Accounts
          </MenuItem>
        </NavDropdown>
      </Nav>
    );

    const navRight = (
      <Nav pullRight className='navbar-top-links'>
        <NavDropdown
          eventKey={1}
          title={user.name || ''}
          id="basic-nav-dropdown"
          href='javascript:void(0);'
        >
          <MenuItem
            href='javascript:void(0);'
            onClick={() => dispatch(push('/advertiser/home/settings'))}
          >
            User Settings
          </MenuItem>
          {false ?
            <MenuItem
              href='javascript:void(0);'
              onClick={() => dispatch(push('/advertiser/home/billing'))}
            >
              Billing
            </MenuItem> : null
          }
          {user.isAdmin ?
            <MenuItem
              href='javascript:void(0);'
              onClick={() => dispatch(push('/admin'))}
            >
              Admin
            </MenuItem> : null
          }
          <Logout />
        </NavDropdown>
      </Nav>
    );

    return (
      <TopHeader sideBtn={title !== 'Accounts'}>
        {(accounts.length === 0 || user.isCustomdash) ? null : navLeft}
        {navRight}
      </TopHeader>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { user, advertiser: { accounts: { data: { data } } } } = state;
  const { account } = ownProps;
  
  return {
    user: user.data,
    accounts: data || [],
    account
  };
};

export default connect(mapStateToProps)(TopNav);
